"use strict";

var ActionsHelper = require("../../actions/ActionsHelper");

var WizardConstants = require("../../constants/WizardConstants");

var GiftArrayValidator = {
	validateDonationMeetsMinimum: function(tangibleStore, context, tangibleCode) {
		var minimumAmount = Number(tangibleStore.getMinimumAmount(context, tangibleCode)) || 0;
		var selectedAmount = Number(tangibleStore.getSelectedAmount(context, tangibleCode)) || 0;
		var storeSubaccountAmounts = tangibleStore.get("subaccountAmounts");
		var subaccountParsed = storeSubaccountAmounts && JSON.parse(JSON.stringify(storeSubaccountAmounts));
		var subaccountAmounts = subaccountParsed && Object.keys(subaccountParsed).map((key) => {
			return [subaccountParsed[key]];
		});

		var subaccountTotal = 0;

		if (subaccountAmounts) {
			subaccountAmounts.forEach(value => {
				subaccountTotal = Number(value) + subaccountTotal;
			});
		}

		var totalAmount = selectedAmount + subaccountTotal;

		var errorMessages = [];
		if (totalAmount < minimumAmount) {
			errorMessages.push(tangibleStore.getWizardValue(
				WizardConstants.WIZARDS.CHECKOUT_MESSAGES,
				WizardConstants.CHECKOUT_MESSAGE_FIELDS.GIFT_AMOUNT_INSUFFICIENT,
				{ formattedAmount: ActionsHelper.formatAmount(minimumAmount, true) }
			));
		}

		return {
			errorMessages,
			isValid: !errorMessages.length
		};
	}
};

module.exports = GiftArrayValidator;
